import type { FlightTracePoint } from '@flightscanner/shared';
import { trimTraceToCurrentFlight } from '@flightscanner/shared';
import { haversineM } from '../lib/geo';

export interface TrailPoint {
  lat: number;
  lon: number;
  t: number;
}

const MAX_POINTS = 1600;
const MIN_STEP_M = 80;

export function traceToTrail(points: FlightTracePoint[]): TrailPoint[] {
  return trimTraceToCurrentFlight(points)
    .filter((p) => Number.isFinite(p.lat) && Number.isFinite(p.lon) && Number.isFinite(p.t))
    .map((p) => ({ lat: p.lat, lon: p.lon, t: p.t }))
    .slice(-MAX_POINTS);
}

/** Append a position sample; skips duplicates and trims by count. */
export function appendTrail(trail: TrailPoint[], lat: number, lon: number, t: number): TrailPoint[] {
  const last = trail[trail.length - 1];
  if (last && haversineM(last, { lat, lon }) < MIN_STEP_M) return trail;
  const next = [...trail, { lat, lon, t }];
  return next.slice(-MAX_POINTS);
}

export function trailToGeoJSON(trail: TrailPoint[]): GeoJSON.FeatureCollection {
  if (trail.length < 2) {
    return { type: 'FeatureCollection', features: [] };
  }
  return {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'LineString',
          coordinates: trail.map((p) => [p.lon, p.lat]),
        },
      },
    ],
  };
}
